import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';

const INIT = 'estimatePictureUpload/INIT';
export const initAction = createAction(INIT);

const CLEAR = 'estimatePictureUpload/CLEAR';
export const clearAction = createAction(CLEAR);

const GET_ESTIMATE_INFO = 'estimatePictureUpload/GET_ESTIMATE_INFO';
export const getEstimateInfoAction = createAction(GET_ESTIMATE_INFO, api.getEstimatesBySeqnumWithSellerUniqueId);

const GET_ESTIMATE_INFO_BY_CARNUM = 'estimatePictureUpload/GET_ESTIMATE_INFO_BY_CARNUM';
export const getEstimateInfoByCarnumAction = createAction(GET_ESTIMATE_INFO_BY_CARNUM, api.getEstimateInfoByCarnum);

const POST_ESTIMATE_PICTURE = 'estimatePictureUpload/POST_ESTIMATE_PICTURE';
export const postEstimatePictureAction = createAction(POST_ESTIMATE_PICTURE, api.postEstimatePicture);

const GET_DECRYPT_ESTIMATE_ID = 'estimatePictureUpload/GET_DECRYPT_ESTIMATE_ID';
export const getDecryptEstimateIdAction = createAction(GET_DECRYPT_ESTIMATE_ID, api.getDecryptEstimateId);

const GET_ENCRYPT_ESTIMATE_ID = 'estimatePictureUpload/GET_ENCRYPT_ESTIMATE_ID';
export const getEncryptEstimateIdAction = createAction(GET_ENCRYPT_ESTIMATE_ID, api.getEncryptEstimateId);

const SET_FRONT_URI = 'estimatePictureUpload/SET_FRONT_URI';
export const setFrontUriAction = createAction(SET_FRONT_URI);

const SET_SEQNUM = 'estimatePictureUpload/SET_SEQNUM';
export const setSeqnumAction = createAction(SET_SEQNUM);

const CHANGE_COMM = 'estimatePictureUpload/CHANGE_COMM';
export const changeAction = createAction(CHANGE_COMM);

const initialState = {
	isInit: false,
	isComplete: false,
	estimateInfo: {},
};

export default handleActions(
	{
		[INIT]: (state) =>
			produce(state, (draft) => {
				draft.isInit = true;
			}),
		[CLEAR]: (state) =>
			produce(state, (draft) => {
				draft.isInit = false;
				draft.isComplete = false;
				draft.estimateInfo = {};
			}),
		[SET_FRONT_URI]: (state, action) =>
			produce(state, (draft) => {
				draft.estimateInfo = {
					...state.estimateInfo,
					front_uri: action.payload,
				};
			}),
		[SET_SEQNUM]: (state, action) =>
			produce(state, (draft) => {
				draft.estimateInfo = {
					...state.estimateInfo,
					seqnum: action.payload,
				};
			}),
		[CHANGE_COMM]: (state, action) =>
			produce(state, (draft) => {
				const { name, value } = action.payload;
				draft[name] = value;
			}),

		...pender({
			type: GET_ESTIMATE_INFO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					if (data) {
						if (data.front_uri) {
							draft.isComplete = true;
						}

						draft.estimateInfo = {
							...data,
						};
					} else {
						draft.estimateInfo = {};
					}
				}),
		}),

		...pender({
			type: GET_DECRYPT_ESTIMATE_ID,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					draft.estimateInfo = {
						...state.estimateInfo,
						seqnum: action.payload.data,
					};
				}),
		}),
	},
	initialState,
);
